<template>
  <nav class="navbar navbar-expand-lg navbar-light bg-light d-print-none" v-show="is_show_header">
    <div class="container-fluid">
      <inertia-link class="navbar-brand" :href="'/'">
        <img :src="logoUrl" alt="" style="height: 40px;">
      </inertia-link>
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav me-auto mb-2 mb-lg-0">
          <li class="nav-item">
            <a class="nav-link" :href="yourraceplanMenuUrl">
              {{ $trans('raceplan.home.PLAN_YOUR_RACE') }}
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="https://www.timingconnect.com">
              {{ $trans('raceplan.home.TRACK_YOUR_RACE') }}
            </a>
          </li>
        </ul>
        <!--
        <form class="d-flex">
          <input class="form-control me-2" type="search" placeholder="Search" aria-label="Search">
          <button class="btn btn-outline-success" type="submit">Search</button>
        </form>
        -->
        <ul class="navbar-nav mb-2 mb-lg-0">
          <li v-if="!auth.loggedIn" class="nav-item">
            <a href="#" class="nav-link" @click="loginClicked()">
              {{ $trans('raceplan.home.login') }}
            </a>
          </li>
          <li v-if="auth.loggedIn" class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
              {{ $trans('raceplan.home.WELCOME') }} {{ auth.user.fullname_en }}
            </a>
            <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdown">
              <li v-if="currentwebsite == 'yourraceplan.com'">
                <inertia-link class="dropdown-item" :href="route('profile')">
                  {{ $trans('raceplan.home.my_profile') }}
                </inertia-link>
              </li>
              <li v-if="auth.loggedIn">
                <template v-if="currentwebsite == 'yourraceplan.com'">
                  <a class="dropdown-item" :href="route('track.organizer.index')" v-if="auth.user.isOrganizer">
                    Organizer Panel
                  </a>
                  <a class="dropdown-item" :href="route('track.mc.index')" v-if="auth.user.isMC">
                    MC Panel
                  </a>
                  <a class="dropdown-item" :href="route('track.cp.index')" v-if="auth.user.isCPStaff">
                    CP Staff Panel
                  </a>
                  <a class="dropdown-item" :href="route('track.medical.index')" v-if="auth.user.isMedical">
                    Medical Panel
                  </a>
                  <a class="dropdown-item" :href="route('track.tourist.index')" v-if="auth.user.isTourist">
                    Tourist Staff Panel
                  </a>
                </template>
                <template v-else>
                  <inertia-link class="dropdown-item" :href="route('track.organizer.index')" v-if="auth.user.isOrganizer">
                    Organizer Panel
                  </inertia-link>
                  <inertia-link class="dropdown-item" :href="route('track.mc.index')" v-if="auth.user.isMC">
                    MC Panel
                  </inertia-link>
                  <inertia-link class="dropdown-item" :href="route('track.cp.index')" v-if="auth.user.isCPStaff">
                    CP Staff Panel
                  </inertia-link>
                  <a class="dropdown-item" :href="route('track.medical.index')" v-if="auth.user.isMedical">
                    Medical Panel
                  </a>
                  <a class="dropdown-item" :href="route('track.tourist.index')" v-if="auth.user.isTourist">
                    Tourist Staff Panel
                  </a>
                </template>
              </li>
              <li><hr class="dropdown-divider"></li>
              <li>
                <a class="dropdown-item" :href="route('track.space')">
                  Runner Space
                </a>
              </li>
              <li>
                <a href="#" class="dropdown-item" @click="logoutClicked()">
                  {{ $trans('raceplan.home.logout') }}
                </a>
              </li>
            </ul>
          </li>
          <li class="nav-item">
            <a class="nav-link icon-header" href="https://www.runningconnect.com/">
              <span class="icon-run"></span>
            </a>
            <a class="nav-link icon-header" href="https://media.runningconnect.com/">
              <span class="icon-camera"></span>
            </a>
            <a class="nav-link icon-header" href="https://www.yourraceplan.com/">
              <span class="icon-yrp"></span>
            </a>
            <a class="nav-link icon-header" href="https://www.timingconnect.com/">
              <span class="icon-timing"></span>
            </a>
            <a class="nav-link icon-header" href="https://shop.runningconnect.com/">
              <span class="icon-shop"></span>
            </a>
          </li>
          <li class="nav-item" style="display: inline-flex;">
            <a href="#" class="nav-link" @click="changeLocale('th')" style="padding-right: 8px;">
              <svg width="20px" xmlns="http://www.w3.org/2000/svg" id="flag-icon-css-th" viewBox="0 0 640 480">
                <g fill-rule="evenodd">
                  <path fill="#f4f5f8" d="M0 0h640v480H0z"/>
                  <path fill="#2d2a4a" d="M0 162.5h640v160H0z"/>
                  <path fill="#a51931" d="M0 0h640v82.5H0zm0 400h640v80H0z"/>
                </g>
              </svg>
            </a>
            <a href="#" class="nav-link" @click="changeLocale('en')">
              <svg width="20px" xmlns="http://www.w3.org/2000/svg" id="flag-icon-css-us" viewBox="0 0 640 480">
                <g fill-rule="evenodd">
                  <g stroke-width="1pt">
                    <path fill="#bd3d44" d="M0 0h972.8v39.4H0zm0 78.8h972.8v39.4H0zm0 78.7h972.8V197H0zm0 78.8h972.8v39.4H0zm0 78.8h972.8v39.4H0zm0 78.7h972.8v39.4H0zm0 78.8h972.8V512H0z" transform="scale(.9375)"/>
                    <path fill="#fff" d="M0 39.4h972.8v39.4H0zm0 78.8h972.8v39.3H0zm0 78.7h972.8v39.4H0zm0 78.8h972.8v39.4H0zm0 78.8h972.8v39.4H0zm0 78.7h972.8v39.4H0z" transform="scale(.9375)"/>
                  </g>
                  <path fill="#192f5d" d="M0 0h389.1v275.7H0z" transform="scale(.9375)"/>
                  <path fill="#fff" d="M32.4 11.8L36 22.7h11.4l-9.2 6.7 3.5 11-9.3-6.8-9.2 6.7 3.5-10.9-9.3-6.7H29zm64.9 0l3.5 10.9h11.5l-9.3 6.7 3.5 11-9.2-6.8-9.3 6.7 3.5-10.9-9.2-6.7h11.4zm64.8 0l3.6 10.9H177l-9.2 6.7 3.5 11-9.3-6.8-9.2 6.7 3.5-10.9-9.3-6.7h11.5zm64.9 0l3.5 10.9H242l-9.3 6.7 3.6 11-9.3-6.8-9.3 6.7 3.6-10.9-9.3-6.7h11.4zm64.8 0l3.6 10.9h11.4l-9.2 6.7 3.5 11-9.3-6.8-9.2 6.7 3.5-10.9-9.2-6.7h11.4zm64.9 0l3.5 10.9h11.5l-9.3 6.7 3.6 11-9.3-6.8-9.3 6.7 3.6-10.9-9.3-6.7h11.5zM64.9 39.4l3.5 10.9h11.5L70.6 57 74 67.9l-9-6.7-9.3 6.7L59 57l-9-6.7h11.4zm64.8 0l3.6 10.9h11.4l-9.3 6.7 3.6 10.9-9.3-6.7-9.3 6.7L124 57l-9.3-6.7h11.5zm64.9 0l3.5 10.9h11.5l-9.3 6.7 3.5 10.9-9.2-6.7-9.3 6.7 3.5-10.9-9.2-6.7H191zm64.8 0l3.6 10.9h11.4l-9.3 6.7 3.6 10.9-9.3-6.7-9.2 6.7 3.5-10.9-9.3-6.7H256zm64.9 0l3.5 10.9h11.5L330 57l3.5 10.9-9.2-6.7-9.3 6.7 3.5-10.9-9.2-6.7h11.4zM32.4 66.9L36 78h11.4l-9.2 6.7 3.5 10.9-9.3-6.8-9.2 6.8 3.5-11-9.3-6.7H29zm64.9 0l3.5 11h11.5l-9.3 6.7 3.5 10.9-9.2-6.8-9.3 6.8 3.5-11-9.2-6.7h11.4zm64.8 0l3.6 11H177l-9.2 6.7 3.5 10.9-9.3-6.8-9.2 6.8 3.5-11-9.3-6.7h11.5zm64.9 0l3.5 11H242l-9.3 6.7 3.6 10.9-9.3-6.8-9.3 6.8 3.6-11-9.3-6.7h11.4zm64.8 0l3.6 11h11.4l-9.2 6.7 3.5 10.9-9.3-6.8-9.2 6.8 3.5-11-9.2-6.7h11.4zm64.9 0l3.5 11h11.5l-9.3 6.7 3.6 10.9-9.3-6.8-9.3 6.8 3.6-11-9.3-6.7h11.5zM64.9 94.5l3.5 10.9h11.5l-9.3 6.7 3.5 11-9.2-6.8-9.3 6.7 3.5-10.9-9.2-6.7h11.4zm64.8 0l3.6 10.9h11.4l-9.3 6.7 3.6 11-9.3-6.8-9.3 6.7 3.6-10.9-9.3-6.7h11.5zm64.9 0l3.5 10.9h11.5l-9.3 6.7 3.5 11-9.2-6.8-9.3 6.7 3.5-10.9-9.2-6.7H191zm64.8 0l3.6 10.9h11.4l-9.2 6.7 3.5 11-9.3-6.8-9.2 6.7 3.5-10.9-9.3-6.7H256zm64.9 0l3.5 10.9h11.5l-9.3 6.7 3.5 11-9.2-6.8-9.3 6.7 3.5-10.9-9.2-6.7h11.4zM32.4 122.1L36 133h11.4l-9.2 6.7 3.5 11-9.3-6.8-9.2 6.7 3.5-10.9-9.3-6.7H29zm64.9 0l3.5 10.9h11.5l-9.3 6.7 3.5 10.9-9.2-6.7-9.3 6.7 3.5-10.9-9.2-6.7h11.4zm64.8 0l3.6 10.9H177l-9.2 6.7 3.5 11-9.3-6.8-9.2 6.7 3.5-10.9-9.3-6.7h11.5zm64.9 0l3.5 10.9H242l-9.3 6.7 3.6 11-9.3-6.8-9.3 6.7 3.6-10.9-9.3-6.7h11.4zm64.8 0l3.6 10.9h11.4l-9.2 6.7 3.5 11-9.3-6.8-9.2 6.7 3.5-10.9-9.2-6.7h11.4zm64.9 0l3.5 10.9h11.5l-9.3 6.7 3.6 11-9.3-6.8-9.3 6.7 3.6-10.9-9.3-6.7h11.5zM64.9 149.7l3.5 10.9h11.5l-9.3 6.7 3.5 10.9-9.2-6.8-9.3 6.8 3.5-11-9.2-6.7h11.4zm64.8 0l3.6 10.9h11.4l-9.3 6.7 3.6 10.9-9.3-6.8-9.3 6.8 3.6-11-9.3-6.7h11.5zm64.9 0l3.5 10.9h11.5l-9.3 6.7 3.5 10.9-9.2-6.8-9.3 6.8 3.5-11-9.2-6.7H191zm64.8 0l3.6 10.9h11.4l-9.2 6.7 3.5 10.9-9.3-6.8-9.2 6.8 3.5-11-9.3-6.7H256zm64.9 0l3.5 10.9h11.5l-9.3 6.7 3.5 10.9-9.2-6.8-9.3 6.8 3.5-11-9.2-6.7h11.4zM32.4 177.2l3.6 11h11.4l-9.2 6.7 3.5 10.8-9.3-6.7-9.2 6.7 3.5-10.9-9.3-6.7H29zm64.9 0l3.5 11h11.5l-9.3 6.7 3.6 10.8-9.3-6.7-9.3 6.7 3.6-10.9-9.3-6.7h11.4zm64.8 0l3.6 11H177l-9.2 6.7 3.5 10.8-9.3-6.7-9.2 6.7 3.5-10.9-9.3-6.7h11.5zm64.9 0l3.5 11H242l-9.3 6.7 3.6 10.8-9.3-6.7-9.3 6.7 3.6-10.9-9.3-6.7h11.4zm64.8 0l3.6 11h11.4l-9.2 6.7 3.5 10.8-9.3-6.7-9.2 6.7 3.5-10.9-9.2-6.7h11.4zm64.9 0l3.5 11h11.5l-9.3 6.7 3.6 10.8-9.3-6.7-9.3 6.7 3.6-10.9-9.3-6.7h11.5zM64.9 204.8l3.5 10.9h11.5l-9.3 6.7 3.5 11-9.2-6.8-9.3 6.7 3.5-10.9-9.2-6.7h11.4zm64.8 0l3.6 10.9h11.4l-9.3 6.7 3.6 11-9.3-6.8-9.3 6.7 3.6-10.9-9.3-6.7h11.5zm64.9 0l3.5 10.9h11.5l-9.3 6.7 3.5 11-9.2-6.8-9.3 6.7 3.5-10.9-9.2-6.7H191zm64.8 0l3.6 10.9h11.4l-9.2 6.7 3.5 11-9.3-6.8-9.2 6.7 3.5-10.9-9.3-6.7H256zm64.9 0l3.5 10.9h11.5l-9.3 6.7 3.5 11-9.2-6.8-9.3 6.7 3.5-10.9-9.2-6.7h11.4zM32.4 232.4l3.6 10.9h11.4l-9.2 6.7 3.5 10.9-9.3-6.7-9.2 6.7 3.5-11-9.3-6.7H29zm64.9 0l3.5 10.9h11.5L103 250l3.6 10.9-9.3-6.7-9.3 6.7 3.6-11-9.3-6.7h11.4zm64.8 0l3.6 10.9H177l-9 6.7 3.5 10.9-9.3-6.7-9.2 6.7 3.5-11-9.3-6.7h11.5zm64.9 0l3.5 10.9H242l-9.3 6.7 3.6 10.9-9.3-6.7-9.3 6.7 3.6-11-9.3-6.7h11.4zm64.8 0l3.6 10.9h11.4l-9.2 6.7 3.5 10.9-9.3-6.7-9.2 6.7 3.5-11-9.2-6.7h11.4zm64.9 0l3.5 10.9h11.5l-9.3 6.7 3.6 10.9-9.3-6.7-9.3 6.7 3.6-11-9.3-6.7h11.5z" transform="scale(.9375)"/>
                </g>
              </svg>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
  <flash-messages class="container" />
  <slot />
</template>

<script>
import FlashMessages from '@/Shared/FlashMessages'
import { computed } from 'vue'
import { usePage } from '@inertiajs/inertia-vue3'
import { setLocale, getLocale } from 'matice'

export default {
  components: {
    FlashMessages,
  },
  data() {
    return {
      logoUrl: location.origin.indexOf('yourraceplan.com') !== -1 ? '/asset/image/logo.svg' : '/asset/image/logo-timing.svg',
      currentwebsite: location.origin.indexOf('yourraceplan.com') !== -1 ? 'yourraceplan.com' : 'timingconnect.com',
      yourraceplanMenuUrl: 'https://www.yourraceplan.com/plan',
      is_show_header: true,
    }
  },
  setup() {
    const auth = computed(() => usePage().props.value.auth)
    return { auth }
  },

  mounted() {
    let url_string = window.location.href
    let url = new URL(url_string)
    let header = url.searchParams.get("header")
    if(header == "false"){
      this.is_show_header = false
    }
  },

  methods: {
    loginClicked() {
      if(location.origin.indexOf('yourraceplan.com') !== -1){
        window.location.href = route('auth.login')
      }else{
        window.location.href = route('track.auth.login')
      }
    },

    registerClicked() {
      if(location.origin.indexOf('yourraceplan.com') !== -1){
        window.location.href = route('auth.login')
      }else{
        window.location.href = route('track.auth.register')
      }
    },

    logoutClicked() {
      let url = "https://www.runningconnect.com/auth/logout"
      url = url + "?referer=" + encodeURIComponent(location.origin)
      window.location.replace(url)
      /*
      const win = window.open(
        url,
        'Log Out');
      const timer = setInterval(() => {
        if (win.closed) {
          clearInterval(timer);
          alert('window closed!');
        }
      }, 500);

       */
    },
    changeLocale(locale){
      localStorage.setItem('locale', locale)
      if(location.origin.indexOf('yourraceplan.com') !== -1){
        window.location.href = route('locale', [locale])
      }else{
        window.location.href = route('track.locale', [locale])
      }
    },
  },
}
</script>
